import React from 'react'
import { Col, Card, CardBody, Media } from 'reactstrap'

export default props => (
  <Col md={4}>
    <Card>
      <CardBody>
        <Media>
          <Media body className="overflow-hidden">
            <p className="text-truncate font-size-14 mb-2">Carga horária restante no mês</p>
            <h4 className="mb-0">{props.value}</h4>
          </Media>
        </Media>
      </CardBody>
      <CardBody className="border-top py-3">
        <div className="text-truncate">
          {props.percentage ? (
            <span className="badge badge-soft font-size-11 mr-1">
              {((1 - props.percentage) * 100).toFixed(0)}
              %
            </span>
          ) : (
            <span className="badge badge-soft font-size-11 mr-1">
              %
            </span>
          )}
          <span className="text-muted ml-1">
            realizado até o momento
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>
)
